import { useMutation, useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { MdOutlineCheck } from "react-icons/md";
import {
  getEachCellStatus,
  getIsRunEnableForCombineDataStatus,
  getProjectWiseUploadedListByEmail,
  runInitialDataQc,
} from "../../../../api/apiCallManager";
import Loader from "../../../../components/spinner/Loader";
import { showError, showSuccess } from "../../../../helpers/alerts";
import WrapperLoader from "../../../../components/spinner/WrapperLoader";
import AccessTo from "../../../../components/is-show/AccessTo";
import { CM } from "../../../router/AddRoutesJson";
import { Tag, Tooltip } from "antd";
import { CONSTANT_CLIENT_PROGRESS_STATUS } from "./rowConstantStatus";
import LogScriptRunErrorModal from "./LogScriptRunError";

function CombineDataCel({ clientProgressData, rowItems }) {
  const [isDisabled, setIsDisable] = useState(false);
  const [showLogError, setShowLogError] = useState(false);
  const onRunError = (data) => {
    setShowLogError(true);
    showError("Run Failed", data?.body);
    setIsDisable(false);
  };
  const runMutation = useMutation({
    mutationFn: runInitialDataQc,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        showSuccess("Script Running...");
        setIsDisable(true);
      } else {
        onRunError(data);
      }
    },
    onError: (error) => {
      onRunError(error);
    },
  });
  const fetchUploadedList = useMutation({
    mutationFn: () =>
      getProjectWiseUploadedListByEmail(rowItems?.siteManager?.email),
    onError: (error) => {
      showError(`Please re-try: ${error.message}`); // Show error alert
    },
    onSuccess: (data) => {
      const filteredFiles =
        data?.filter(
          (file) => file?.siteName === rowItems?.siteManager?.siteName
        ) || [];

      if (filteredFiles.length) {
        const payload = {
          rowItems,
          filteredSpecificSiteFile: filteredFiles,
          eventType: "combined_data_script_run",
          siteName: clientProgressData[0]?.siteManager?.map(
            (test) => test?.siteName
          ),
        };
        runMutation.mutate(payload); // Run mutation after data is fetched
      }
    },
  });
  const handleFailed = () => {
    setShowLogError(Math.random());
  };
  const handleRun = () => {
    fetchUploadedList.mutate(); // Trigger the fetch mutation
  };

  const renderStatusComponent = (status) => {
    switch (true) {
      case CONSTANT_CLIENT_PROGRESS_STATUS.RUNNING?.includes(status):
        return <Tag color="green">Running</Tag>; // Show "Running" text and skip other components
      case CONSTANT_CLIENT_PROGRESS_STATUS.PENDING?.includes(status):
        return (
          <AccessTo
            role={[CM]}
            fallBackComponent={<Tag color="orange"> Run Enabled</Tag>}
          >
            <button
              disabled={isDisabled}
              className="bg-green-600 text-white  px-2 rounded-sm"
              onClick={() => handleRun()}
            >
              {runMutation.isPending || fetchUploadedList.isPending ? (
                <Loader
                  isLoading={
                    runMutation.isPending || fetchUploadedList.isPending
                  }
                />
              ) : (
                "Run"
              )}
            </button>
          </AccessTo>
        );
      case CONSTANT_CLIENT_PROGRESS_STATUS.SUCCESS?.includes(status):
        return (
          <Tooltip title="Combine QC Completed">
            <MdOutlineCheck color="green" size={16} />
          </Tooltip>
        );
      case CONSTANT_CLIENT_PROGRESS_STATUS.FAILED?.includes(status):
        return (
          <button onClick={handleFailed}>
            <Tag color={"red"}>
              {/* <BsFillInfoCircleFill color="#fd5252" /> */}
              Failed
            </Tag>
          </button>
        );
      default:
        return <IoCloseOutline color="red" size={16} />; // Default case for other statuses
    }
  };

  return (
    <div className="flex justify-center">
      {/* {JSON.stringify({
        rowItems,
        eventType: "combined_data_script_run",
        siteName: clientProgressData[0]?.siteManager?.map((test) => test?.siteName),
      })}
      ========
      {JSON.stringify(
        clientProgressData[0]?.siteManager?.map((test) => test?.siteName)
      )} */}
      <LogScriptRunErrorModal
        scriptType={"combine-data"}
        rowItems={rowItems}
        showLogError={showLogError}
        setShowLogError={setShowLogError}
      />

      <WrapperLoader isLoading={!rowItems?.celStatus}>
        {renderStatusComponent(rowItems?.celStatus?.combine_data)}
      </WrapperLoader>
    </div>
  );
}

export default CombineDataCel;
